module.exports = __webpack_public_path__ + "img/spawner-idle-mask.fe28543b.png";